import { Navigate } from 'react-router-dom';
import { RouteErrorBoundary } from 'components/ErrorBoundary';
import DashboardLayout from 'layout/Dashboard';
import ProtectedRoute from './ProtectedRoute';

// Dashboard module
import dashboardRoutes from 'modules/dashboard/dashboard.routes';

// Enterprise module
import enterpriseRoutes from 'modules/enterprise/enterprise.routes';

// Employees module
import employeeRoutes from 'modules/employee/employee.routes';

// Leave module
import leaveRoutes from 'modules/leave/leave.routes';

// Attendance module
import attendanceRoutes from 'modules/attendance/attendance.routes';

// Payroll module
import payrollRoutes from 'modules/payroll/payroll.routes';

// Expense module
import expenseRoutes from 'modules/expenses/expense.routes';

// Project module
import projectRoutes from 'modules/projects/project.routes';

// Asset module
import assetRoutes from 'modules/assets/asset.routes';

// Performance module
import performanceRoutes from 'modules/performance/performance.routes';

// Recruitment module
import recruitmentRoutes from 'modules/recruitment/recruitment.routes';

// Course module
import courseRoutes from 'modules/courses/course.routes';

// User Management module
import userManagementRoutes from 'modules/userManagement/userManagement.routes';

// System Configuration module
import systemConfigurationRoutes from 'modules/systemConfiguration/systemConfiguration.routes';

// Meeting module
import meetingRoutes from 'modules/meetings/meeting.routes';
import { MeetingProvider } from 'contexts/MeetingContext';

const MainRoutes = {
  path: '/',
  element: (
    <ProtectedRoute>
      <MeetingProvider>
        <DashboardLayout />
      </MeetingProvider>
    </ProtectedRoute>
  ),
  errorElement: <RouteErrorBoundary />,
  children: [
    { index: true, element: <Navigate to="/dashboard/default" replace /> },
    dashboardRoutes,
    enterpriseRoutes,
    leaveRoutes,
    attendanceRoutes,
    payrollRoutes,
    expenseRoutes,
    projectRoutes,
    assetRoutes,
    performanceRoutes,
    recruitmentRoutes,
    courseRoutes,
    userManagementRoutes,
    employeeRoutes,
    systemConfigurationRoutes,
    meetingRoutes
  ]
};

export default MainRoutes;
